import { PublicLayout } from "@/components/Layout";
export function Termos() {
  return (<PublicLayout><div className="max-w-3xl mx-auto px-6 py-12">
    <h1 className="text-3xl font-extrabold mb-4" style={{fontFamily:"Plus Jakarta Sans"}}>Termos de Uso</h1>
    <p className="text-slate-700 leading-relaxed">O GIRO+SAÚDE é uma plataforma regional de conexão entre pessoas e profissionais/serviços de saúde. Não realizamos diagnósticos, não prescrevemos medicamentos e não substituímos o atendimento profissional. Ao utilizar a plataforma, você concorda com estes termos.</p>
  </div></PublicLayout>);
}
export function Privacidade() {
  return (<PublicLayout><div className="max-w-3xl mx-auto px-6 py-12">
    <h1 className="text-3xl font-extrabold mb-4" style={{fontFamily:"Plus Jakarta Sans"}}>Política de Privacidade & LGPD</h1>
    <p className="text-slate-700 leading-relaxed">Tratamos seus dados pessoais em conformidade com a LGPD, com finalidade específica, minimização e segurança adequada. Dados de saúde recebem tratamento especial e não são utilizados para publicidade sem consentimento e estrutura legal apropriada.</p>
  </div></PublicLayout>);
}
